import type { PhoneNumber } from "@repo/types";

export const phoneNumberRepo = {
  init: (data?: Partial<PhoneNumber>): PhoneNumber => {
    return {
      type: "mobile",
      number: "",
      ...data,
    };
  },
};
